export default __webpack_public_path__ + "static/media/feather_plus-circle-enable.4dde8183.svg";